import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'typed-values'
const verb = 'get'

export default class OspreyTypedValueMetadata extends BaseAction {
    constructor() {
        const id = 'cf8f702d-726d-43f6-a689-5118421cecc9'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = true
    }

    getMetadata(params) {
        this.params = params

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/typed-value/typed-value-metadata.js